module.exports = __webpack_public_path__ + "static/combination-of-different-series-types-9c7bbb50f2585f9d78ed88ff2f2a1365.png";